import { History } from '@app/home/models/history.model';
import { SimulationMetadata } from '@core/models/simulation-metadata.model';
import { createAction, props } from '@ngrx/store';
import { DateTime } from 'luxon';

import {
  MetricChangeHistory,
  TimestreamMetric,
  TimestreamMetricUpdate,
  TimestreamRangeTransfert,
  TimestreamRangeUpdate
} from '../../../models/metric.model';
import { ChartStep } from '../models/chart-step';
import { Interval } from '../models/interval';
import { SelectedRange } from '../models/revogrid-definition.model';

export const resetState = createAction('[Analysis] Reset state');

export const init = createAction(
  '[Analysis] Init',
  props<{
    endDate: DateTime;
    metrics: Array<TimestreamMetric>;
    tab: 'chart' | 'table';
    prsim: SimulationMetadata;
    hreko: SimulationMetadata;
  }>()
);

export const toggleTreeView = createAction('[Analysis] Toggle tree view');

export const loadMetricsSuccess = createAction(
  '[Analysis] Load metrics success',
  props<{ metrics: Array<TimestreamMetric> }>()
);
export const loadMetricsError = createAction('[Analysis] Load metrics failure');

export const selectMetric = createAction(
  '[Analysis] Select metric',
  props<{
    metric: TimestreamMetric;
  }>()
);
export const unselectMetric = createAction('[Analysis] Unselect metric', props<{ metric: TimestreamMetric }>());

export const switchTab = createAction('[Analysis] Switch tab', props<{ tab: 'chart' | 'table' }>());
export const close = createAction('[Analysis] Close');

export const updateDateRange = createAction(
  '[Analysis] Update date range',
  props<{ endDate: DateTime; startDate?: DateTime; source?: 'calendar' | 'single-step' | 'next-step' | 'custom' }>()
);
export const switchInterval = createAction(
  '[Analysis] Switch interval',
  props<{ interval: Interval; step?: ChartStep }>()
);

// Chart
export const previousSlice = createAction('[Analysis] Previous slice');
export const nextSlice = createAction('[Analysis] Next slice');
export const changeChartStep = createAction('[Analysis] Change chart step', props<{ step: ChartStep }>());

// Déphasage
export const togglePhaseShift = createAction('[Analysis] Toggle phase shift');
export const changePhaseShift = createAction(
  '[Analysis] Change phase shift',
  props<{ index: number; phaseShift: number }>()
);
export const duplicatePhaseShiftMetric = createAction(
  '[Analysis] Duplicate phase shift metric',
  props<{ index: number }>()
);
export const removePhaseShiftMetric = createAction('[Analysis] Remove phase shift metric', props<{ index: number }>());

// Table
export const changeTableStepSize = createAction('[Analysis] Change table step size', props<{ stepSize: number }>());
export const toggleComparaisonExpandedHeader = createAction('[Analysis] Toggle comparaison expanded header');
export const nextComparaisonHeaderSlice = createAction('[Analysis] Next comparaison header slice');
export const previousComparaisonHeaderSlice = createAction('[Analysis] Previous comparaison header slice');
export const downloadFile = createAction('[Analysis] Download file');

// Toolbar
export const togglePanel = createAction(
  '[Analysis] Toggle panel',
  props<{ panel: 'edit' | 'transfert' | 'history' | 'launch-simulation' | 'change-history' }>()
);
export const selectRange = createAction('[Analysis] Select range', props<{ selectedRange: SelectedRange }>());
export const updateData = createAction('[Analysis] Update data', props<{ data: Array<TimestreamMetricUpdate> }>());
export const updateDataSuccess = createAction('[Analysis] Update data success');
export const updateDataError = createAction('[Analysis] Update data failure');

export const updateRangeData = createAction('[Analysis] Update range data', props<{ data: TimestreamRangeUpdate }>());
export const transfertRangeData = createAction(
  '[Analysis] Transfert range data',
  props<{ data: TimestreamRangeTransfert }>()
);
export const updateRangeDataSuccess = createAction('[Analysis] Update range data success');
export const updateRangeDataError = createAction('[Analysis] Update range data failure');

// History
export const getHistoryForKeyError = createAction('[Analysis] Get history for key error');
export const getHistoryForKeySuccess = createAction(
  '[Analysis] Get history for key success',
  props<{ history: Array<History> }>()
);
export const addToChangeHistory = createAction(
  "[Analysis] Add metric's change to change history",
  props<{ data: MetricChangeHistory }>()
);
export const addChangeHistorySuccess = createAction(
  "[Analysis] Add metric's change to change history success",
  props<{ newHistory: MetricChangeHistory }>()
);
export const removeLastChangeInHistory = createAction('[Analysis] Remove last change in change history');
export const resetChangeHistory = createAction('[Analysis] Reset change history');
